









































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import MokYun from '@/components/MokYun.vue';
import { Button, Tab, Tabs, Form, Field } from 'vant';
import { Api } from '@/utils/request';
@Component({
  components: {
    MokYun,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Field.name]: Field,
  },
})
export default class Mokyun extends Vue {
  // 是否吸顶
  public navBarFixed = false;
  public active = 1;
  public currentIndex = 1;
  public productIndex = 1;
  public isPhone = false;
  public menuList = [
    { name: '后端云', index: 1, link: '#home' },
    { name: '产品体验', index: 2, link: '#product' },
    { name: '产品优势', index: 3, link: '#progress' },
    { name: '合作伙伴', index: 5, link: '#company' },
    { name: '联系我们', index: 6, link: '#contact' },
    { name: '开发手册', index: 4, link: '' },
  ];
  public productDetail = {};
  public productList = [
    {
      current: 1,
      name: '越野在现场',
      url: require('@/assets/images/qrcodes/yueye.jpg'),
      describe: '#让你更贴近现场#看直播，抢特价！户外运动图片短视频播报',
      flag: '越野更实时、有趣',
      example: require('@/assets/images/examples/yueye.png'),
    },
    // {
    //   current: 2,
    //   name: '中电55单片',
    //   url: require('@/assets/images/examples/ziliao.jpg'),
    //   describe:
    //     '中电国基南方集团有限公司单片电路事业部选型指南。提供微波毫米波芯片、模块产品、套片方案资料。',
    //   flag: '查看产品、更加方便',
    //   example: require('@/assets/images/examples/55ziliao.png'),
    // },
    {
      current: 2,
      name: '保粹钱币',
      url: require('@/assets/images/qrcodes/baocui.jpg'),
      describe: '一款解决钱币学习小程序',
      flag: '鉴定钱币、足够智能',
      example: require('@/assets/images/examples/baocui.png'),
    },
    {
      current: 3,
      name: '跑者说2020 ',
      url: require('@/assets/images/qrcodes/runner.jpg'),
      example: require('@/assets/images/examples/paozhe.png'),
      describe:
        '每一次奔跑都应该被记录，每一次进度都能赢得掌声，每一次坚持都值得被鼓励，2020我们共同谱写跑者的歌。',
      flag: '跑者留言、及时互动',
    },
    {
      current: 4,
      name: '药惠享',
      url: require('@/assets/images/qrcodes/yaohuixiang.jpg'),
      example: require('@/assets/images/examples/yaohuixiang.png'),
      describe: '一个提供超多药用优惠券领取的平台',
      flag: '药品购买、超级便捷',
    },
    {
      current: 5,
      name: '钱币大师',
      url: require('@/assets/images/qrcodes/baocui.jpg'),
      example: require('@/assets/images/examples/xiaoyouxi.png'),
      describe: '一款在线鉴定钱币的小程序',
      flag: '钱币游戏、先来玩玩',
    },
    {
      current: 6,
      name: '巟度',
      url: '',
      example: require('@/assets/images/examples/minsu.png'),
      describe: '一款在线预定酒店民宿的小程序，在巟度，享受美好时光。',
    },
    {
      current: 7,
      name: '金城闪租',
      url: '',
      example: require('@/assets/images/examples/shanzu.png'),
      describe:
        '以“服务到家，客户满意”为宗旨，努力为客户提供优质服务。“优质车辆，星级服务”是对客户的承诺。',
    },
  ];
  public companyList = [
    'https://cdn1-open.mokyun.com/1539595693868',
    'https://cdn1-open.mokyun.com/1539595746660',
    'https://cdn1-open.mokyun.com/1539595767347',
    'https://cdn1-open.mokyun.com/1539595705234',
    'https://cdn1-open.mokyun.com/1539595720849',
    'https://cdn1-open.mokyun.com/1539595786197',
    'https://cdn1-open.mokyun.com/1539595734455',
    'https://cdn1-open.mokyun.com/1539595798939',
  ];
  public goodnessList = [
    {
      url: require('@/assets/images/brain.png'),
      title: '先进热门',
      content: '采用先进的TS，严谨、高效，提供丰富的包管理及对接标准',
    },
    {
      url: require('@/assets/images/bushu.png'),
      title: '智能部署',
      content:
        '开发者只需要通过图像话界面建立数据表+SQL语句，自动生成丰富的API接口',
    },
    {
      url: require('@/assets/images/open.png'),
      title: '高效实用',
      content: '采用先进成熟的server微服务技术，每个应用之间低耦合，应用广泛',
    },
    {
      url: require('@/assets/images/settings.png'),
      title: '透明开放',
      content: '应用DOCER部署，所有应用可控分配，数据可读轻储',
    },
  ];
  public introduction = '';

  //导航栏吸顶
  async mounted() {
    window.addEventListener('scroll', this.watchScroll);
    await this.getProducts();
    await this.getAdvance();
  }
  // 获取产品
  async getProducts() {
    this.productList = await Api.Product.getList();
    this.productDetail = await Api.Product.getDetails({
      id: Number((this.productList[0] as any).id),
    });
  }
  // 获取产品优势介绍、合作伙伴
  async getAdvance() {
    this.goodnessList = await Api.Advantage.get({});
    this.companyList = await Api.Partner.get({});
    this.introduction = await Api.Config.get();
  }
  watchScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    //  当滚动超过 310 时，实现吸顶效果
    if (scrollTop > 310) {
      this.navBarFixed = true;
      // console.log('吸顶',scrollTop)
    } else {
      this.navBarFixed = false;
      // console.log('不吸顶',scrollTop)
    }
  }

  // 公司官网
  public linkCompany(num: any) {
    if (num === 1) {
      // window.location.href=
      window.open('https://www.mokyun.com/', 'false');
      return false;
    } else if (num === 3) {
      window.open('https://beian.miit.gov.cn', 'false');
      return false;
    } else {
      window.open('https://open.mokyun.com/', 'false');
      return false;
    }
  }
  // 导航栏
  public linkContent(index: any) {
    this.currentIndex = index;
    if (index === 4) {
      window.open('https://mobox.book.mokyun.com/');
    }
  }
  //产品体验选择
  async linkProduct(index: any) {
    console.log(index);

    this.productDetail = await Api.Product.getDetails({
      id: Number(index),
    });
  }
  // 展示二维码
  showPhone() {
    this.isPhone = true;
  }
  closePhone() {
    this.isPhone = false;
  }
}
